import { Component, OnDestroy } from '@angular/core';

import { AbstractComponent } from './abstract-component';

@Component({
  template: '',
  standalone: false,
})
export abstract class BaseComponent extends AbstractComponent implements OnDestroy {
  constructor() {
    super();
  }
}
